export default __webpack_public_path__ + "static/media/aboutHero.8821378c.jpg";